import type { ForwardedRef, ImgHTMLAttributes } from 'react'
import { forwardRef } from 'react'
import style from './style.module.sass'

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
	width?: number
	height?: number
}

export const Icon = forwardRef(
	(
		{ width, height, ...rest }: Props,
		ref: ForwardedRef<HTMLImageElement>
	) => {
		return (
			<img
				{...rest}
				draggable={false}
				ref={ref}
				data-yakiniku="icon"
				style={{
					width: (width ?? height ?? 8) * 2,
					height: (height ?? width ?? 8) * 2,
					...rest.style
				}}
				className={`icon ${rest.className} ${style.icon}`}
			/>
		)
	}
)
